$(function () {
    if ($("#changeCFAModal").length > 0) {

        $("#addChangeforCFA").on('click', function () {
            $('.form-check-input').each(function () {
                this.checked = false;
            }); 

            $("#changetypeError").addClass("d-none");
            $("#questiontypeError").addClass("d-none");
            $("#incomedivError").addClass("d-none");
            $("#maritaldivError").addClass("d-none");
            $("#samemartialcdError").addClass("d-none");
            $("#incomediv").addClass("d-none");
            $("#maritaldiv").addClass("d-none");
            $("#incomequestiondiv").addClass("d-none");


            $("#changeCFAModal").modal('show');
            return false;
        });

        $(".changeradio").on("change", function (e) {
            e.preventDefault();
            e.stopPropagation();

            $("#changetypeError").addClass("d-none");
            $("#questiontypeError").addClass("d-none");
            $("#incomedivError").addClass("d-none");
            $("#maritaldivError").addClass("d-none");
            $("#samemartialcdError").addClass("d-none");
            $("#incomediv").addClass("d-none");
            $("#maritaldiv").addClass("d-none");
            $("#incomequestiondiv").addClass("d-none");

            //var applicationtypecd = $("input[name='questiontype']:checked").val();
            var selectedtypecd = $("input[name='changetype']:checked").val();

            var applicantcount = $("#applicantcount").val();

            var jsIncomeTypeCd = $("#incometypecd").val();
            var jsMartialTypeCd = $("#martialtypecd").val();
            var jsOtherTypeCd = $("#othertypecd").val();


            if (selectedtypecd != jsOtherTypeCd) {
                $("#maritaldiv").addClass("d-none");
                $("#incomediv").addClass("d-none");
                $("#incomequestiondiv").addClass("d-none");

                if (selectedtypecd == jsIncomeTypeCd && applicantcount > 1) {
                    $("#incomediv").removeClass("d-none");
                    $("#maritaldiv").addClass("d-none");
                }

                if (selectedtypecd == jsMartialTypeCd) {
                    $("#maritaldiv").removeClass("d-none");
                    $("#incomediv").addClass("d-none");
                }
            }



            //if ($('input[id="incomequestion"]:checked').length > 0) {
            //    $("#incomequestiondiv").removeClass("d-none");
            //    return false;
            //}
        })

        $("#submitChangeBtn").on("click", function () {

            if ($('input[name="changetype"]:checked').length == 0) {
                $("#changetypeError").removeClass("d-none");
                return false;
            }

            //var selectedtypecd = $("input[name='changetype']:checked").val();
            //var applicationtypecd = $('input[name="questiontype"]:checked').val();

            var applicationtypecd = $('input[name="changetype"]:checked').val();

            var maritalStatuscd = $('input[name="martialstatus"]:checked').val();
            var applicantcount = $("#applicantcount").val();

            var jsIncomeTypeCd = $("#incometypecd").val();
            var jsMartialTypeCd = $("#martialtypecd").val();
            var jsTerminateTypeCd = $("#terminatetypecd").val();
            var jsOtherTypeCd = $("#othertypecd").val();
            
            // Terminations have their own workflow. We don't create an application until the user finishes the process.
            if (applicationtypecd == jsTerminateTypeCd) {
                var url = ''

                if (location.href.indexOf('/en/') > 0) {
                    url = location.href.split('/en/')[0] + '/en/financialassistance/home/ApplicationTermination/?id=' + $("#applicationId").val();
                } else {
                    url = location.href.split('/fr/')[0] + '/fr/financialassistance/home/ApplicationTermination/?id=' + $("#applicationId").val();
                }

                window.location.href = url;

                return;
            }

            //if (selectedtypecd != jsOtherTypeCd && $('input[name="questiontype"]:checked').length == 0) {
            //    $("#questiontypeError").removeClass("d-none");
            //    return false;
            //}

            var currentmartialstatusCd = $("#currentmartialstatuscd").val();

            if (applicationtypecd == jsIncomeTypeCd && applicantcount > 1) {

                if ($('input[name="applicant"]:checked').length == 0) {
                    $("#incomedivError").removeClass("d-none");
                    return false;
                }
            } else if (applicationtypecd == jsMartialTypeCd) {

                if ($('input[name="martialstatus"]:checked').length == 0) {
                    $("#maritaldivError").removeClass("d-none");
                    return false;
                }

                if (maritalStatuscd == currentmartialstatusCd) {
                    $("#samemartialcdError").removeClass("d-none");
                    return false;
                }
            }

            var ids = [];
            $(".applicantId:checked").each(function (e) {
                ids.push($(this).data('perm'));
            });

            var selectedapplicants = ids.join(',');

            var url = '';

            var programurl = ''

            appId = $("#applicationId").val();
            primaryapplicantid = $("#primaryapplicantid").val();
            cfaeligibleId = $("#cfaeligiblerecordId").val();

            var formData = new FormData();

            formData.append('ApplicationId', appId);
            formData.append('SelectedApplicationTypeCd', applicationtypecd);
            formData.append('MartialStatusCd', maritalStatuscd);
            formData.append('SelectedApplicants', selectedapplicants);
            formData.append('PrimaryApplicantEligibilityId', primaryapplicantid);
            formData.append('CFAEligibileRecordId', cfaeligibleId);

            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/financialassistance/home/changecfa/';
            } else {
                url = location.href.split('/fr/')[0] + '/fr/financialassistance/home/changecfa/';
            }

            if (location.href.indexOf('/en/') > 0) {
                programurl = location.href.split('/en/')[0] + '/en/myaccount/programsservices/';
            } else {
                programurl = location.href.split('/fr/')[0] + '/fr/myaccount/programsservices/';
            }

            $.ajax({
                url: url,
                type: 'POST',
                contentType: false,
                processData: false,
                data: formData,
                success: function (res) {
                    $('.form-check-input').each(function () {
                        this.checked = false;
                    }); 

                    $("#changeCFAModal").modal("hide");

                    if (res.SelectedApplicationTypeCd == jsMartialTypeCd && (res.MartialStatusCd == "1" || res.MartialStatusCd == "3")) {

                        window.location.href = programurl;
                    }
                    else {
                        url = url.replace('changecfa', 'ApplicantInfo') + '?id=' + res.ApplicationId;

                        window.location.href = url;
                    }
                }
            });
        })

        $("input[name='martialstatus']").on('change', function () {

            $("#maritaldivError").addClass("d-none");
            $("#samemartialcdError").addClass("d-none");
        })

        $("input[name='applicant']").on('change', function () {

            $("#incomedivError").addClass("d-none");
        })

        $("input[name='changetype']").on('change', function () {

            $("#changetypeError").addClass("d-none");
        })

        $("input[name='questiontype']").on('change', function () {

            $("#questiontypeError").addClass("d-none");
        })
    }
});